import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import organizationUsersResource from 'src/actions/imitate/organizationUsersResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useOrganizationUsers(organizationId: string) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchOrganizationUsers(organizationId));
    return () => {
      dispatch(organizationUsersResource.effects.unload());
    };
  }, [dispatch, organizationId]);

  return useResourceValues(organizationUsersResource);
}

const fetchOrganizationUsers: sharedTypes.AppThunk = (organizationId: string) => async dispatch => {
  dispatch(organizationUsersResource.effects.fetchAll({ orgId: organizationId }));
};
